import { http } from '@/shared/lib/http';

import type { CurrentUser, LoginRequest, LoginResponse } from './auth.types';

/**
 * API calls da feature auth. Todas usam o `http` global (com refresh
 * automático em 401 + Authorization Bearer). NÃO chame `fetch` direto.
 */
export const authApi = {
  login: (req: LoginRequest) =>
    http.post('auth/login', { json: req }).json<LoginResponse>(),

  refresh: (refreshToken: string) =>
    http.post('auth/refresh', { json: { refreshToken } }).json<LoginResponse>(),

  logout: (refreshToken: string) =>
    http.post('auth/logout', { json: { refreshToken } }).json<void>(),

  me: () => http.get('auth/me').json<CurrentUser>(),
};
